import CustomCheckbox from '../common/CustomeCheckbox';

export default function MarketsSection({handleCheckAllMarket, selectAllMarketsCheckboxValue, marketCheckboxValues,
    toggleMarketDropdown, handleCheckMarket, handleCheckMarketStation, showAddCoordinateDropdown
}) {
    return (
        <div style={{ 'marginTop': 10, width: '93%', 'marginLeft': 10, backgroundColor: '#f5dfc1', borderWidth: 1, borderColor: '#dcb681', height: "47%" }}>
            <h2 style={{ 'marginLeft': '5px' }}>
                <strong>Markets</strong>
            </h2>

            <div style={{ 'margin': '0px 10px 10px', 'height': showAddCoordinateDropdown ? '75%' : '80%', 'overflowY': 'scroll' }}>
                <label>
                    <input
                        type="checkbox"
                        onChange={(value) => handleCheckAllMarket(value, 'market')}
                        checked={selectAllMarketsCheckboxValue}
                    />
                    <span style={{ 'marginLeft': 5 }}>Select All</span>
                </label>
                {
                    marketCheckboxValues.map((marketCheckboxValue, index) => (
                        <CustomCheckbox 
                            key={index}
                            index={index} 
                            entityCheckboxValue={marketCheckboxValue} 
                            toggleDropdown={toggleMarketDropdown} 
                            handleCheck={(value, index) => handleCheckMarket(value, index, 'market')} 
                            handleCheckSingleEntity={(value, index, singleIndex) => handleCheckMarketStation(value, index, singleIndex, 'market')} 
                        />
                    ))
                }
            </div>
        </div>
    )
}